<template>
    <div class="item"><p class="title" @click="opened=!opened"><span>Комментарии к версии материала от {{commentsGroup.date}}</span>
    </p>
        <dropdown-item-component :visible="opened">
            <post-comments :comments="commentsGroup.comments" :can-answer="false"></post-comments>
        </dropdown-item-component>
    </div>
</template>

<script>
    import DropdownItemComponent from "../common/Dropdown";
    export default {
        name: 'old-post-comments',
        components: {
            DropdownItemComponent,
        },
        props: {
            commentsGroup: Object,
        },
        data() {
            return { opened: false}
        }
    }

</script>

<style scoped>

</style>
